import React from 'react';
import { Task } from '../../types/task';
import TimeTracker from './TimeTracker';
import CustomModal from '../common/CustomModal';
import { useLanguage } from '../../contexts/LanguageContext';
import { ClockIcon } from '@heroicons/react/24/outline';

interface TimeTrackingModalProps {
  isOpen: boolean;
  onClose: () => void;
  task: Task;
  organizationId: string;
}

export default function TimeTrackingModal({
  isOpen,
  onClose,
  task,
  organizationId
}: TimeTrackingModalProps) {
  const { t } = useLanguage();

  const subtitle = (
    <>
      {task.taskNumber && (
        <span className="font-mono bg-white/20 px-2 py-0.5 rounded mr-2">
          {task.taskNumber}
        </span>
      )}
      {task.title}
    </>
  );

  const headerContent = (
    <div className="flex items-center space-x-3">
      <div className="text-right">
        <div className="text-xs font-medium text-white/70 uppercase tracking-wide">
          {t('tasks.fields.status')}
        </div>
        <div className="text-sm font-semibold text-white capitalize">
          {t(`tasks.status.${task.status}`)}
        </div>
      </div>
      <div className="text-right">
        <div className="text-xs font-medium text-white/70 uppercase tracking-wide">
          {t('tasks.fields.priority')}
        </div>
        <div className="text-sm font-semibold text-white capitalize">
          {t(`tasks.priority.${task.priority}`)}
        </div>
      </div>
    </div>
  );

  const footer = (
    <button
      onClick={onClose}
      className="w-full sm:w-auto px-6 py-3 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-200 font-medium rounded-xl transition-all"
    >
      {t('common.actionsObject.close')}
    </button>
  );

  return (
    <CustomModal
      isOpen={isOpen}
      onClose={onClose}
      title={t('timeTracking.title')}
      subtitle={subtitle}
      icon={ClockIcon}
      size="5xl"
      gradient="blue"
      headerContent={headerContent}
      footer={footer}
    >
      <TimeTracker
        taskId={task.id}
        organizationId={organizationId}
      />
    </CustomModal>
  );
}
